/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disabled no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { IBEError } from '@common/interfaces/be-error.interface';
import { CustomAxiosResponse } from '@common/interfaces/custom-axios-response.interface';
import { CustomPromise } from '@common/interfaces/custom-promise.interface';
import { IRequestService, requestService } from '@common/services/request.service';
import { formatUrl } from '@common/utils/format-url.util';
import { BE_API_URLS } from '@src/shared/be-api-urls.constant';

const API_SERVER_URL = BE_API_URLS.registrationService.apiUrl;

export enum EFeature {
    example = 'example',
}

// DON'T REMOVE THIS COMMENTS!!! Code between comments auto-generated
// INSERT START
export interface IRegisterRequest {
    email?: string;
    password?: string;
    id_token?: string;
    refresh_token?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    billing_address?: {
        label?: string;
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    metadata?: any;
    payment_method?: {
        type?: string;
    };
    shipping_address?: {
        label?: string;
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    box_id?: string;
    subscription_items?: Array<{
        quantity?: number;
        item_price_id?: string;
    }>;
    gateway_temporary_token?: string;
    payment_intent?: {
        id?: string;
    };
    stripe_setup_intent_id?: string;
    stripe_permanent_token_id?: string;
    cf_additional_email?: string;
    cf_safe_place?: string;
    cf_dislikes?: string;
    cf_discount?: string;
    cf_delivery_configuration_id?: string;
    cf_w3w?: string;
    cf_landing_url?: string;
    cf_s2s_consent?: boolean;
    start_date?: number;
    next_delivery_date?: string;
    email_subscribe?: string;
    push_subscribe?: string;
    email_subscription_groups?: {
        addons?: boolean;
        general_marketing?: boolean;
        weekly_newsletter?: boolean;
        '3rd_party'?: boolean;
        surveys?: boolean;
    };
    sms_subscription_groups?: {
        sms?: boolean;
        sms_transactional?: boolean;
    };
    postal_preference?: boolean;
    telephone_preference?: boolean;
}
export interface ISignUpRequest {
    email?: string;
    password?: string;
    id_token?: string;
    refresh_token?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    metadata?: any;
    cf_additional_email?: string;
    cf_safe_place?: string;
    cf_dislikes?: string;
    cf_discount?: string;
    cf_w3w?: string;
    cf_landing_url?: string;
    cf_s2s_consent?: boolean;
}
export interface IOrderEstimateRequest {
    plan_item_price_id?: string;
    delivery_configuration_id?: string;
    coupon_id?: string;
}
export interface ICredentials {
    email?: string;
    password?: string;
}
export interface IRefresh {
    id_token?: string;
    refresh_token?: string;
}
export interface IEmail {
    email?: string;
}
export interface ICustomerDataUpdate {
    phone?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    billing_address?: {
        label?: string;
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    metadata?: any;
    cf_additional_email?: string;
    cf_s2s_consent?: boolean;
}
export interface IChangePassword {
    old_password?: string;
    new_password?: string;
    access_token?: string;
}
export interface IForceChangePassword {
    token?: string;
    email?: string;
    old_password?: string;
    new_password?: string;
}
export interface IForgotPassword {
    username?: string;
}
export interface IForgotPasswordConfirm {
    username?: string;
    password?: string;
    code?: string;
}
export interface IPaymentSourceRequestBody {
    payment_intent_id?: string;
    stripe_setup_intent_id?: string;
    stripe_permanent_token_id?: string;
    billing_address?: {
        label?: string;
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
}
export interface IMarketingPreferencesRequestBody {
    email_subscribe: string;
    push_subscribe: string;
    email_subscription_groups: {
        addons?: boolean;
        general_marketing?: boolean;
        weekly_newsletter?: boolean;
        '3rd_party'?: boolean;
        surveys?: boolean;
    };
    sms_subscription_groups: {
        sms?: boolean;
        sms_transactional?: boolean;
    };
    postal_preference: boolean;
    telephone_preference: boolean;
}
export interface ITrackAliasRequestBody {
    email: string;
    event_name: string;
    first_name?: string;
    last_name?: string;
    zip?: string;
    email_subscribe?: string;
    push_subscribe?: string;
    email_subscription_groups?: {
        addons?: boolean;
        general_marketing?: boolean;
        weekly_newsletter?: boolean;
        '3rd_party'?: boolean;
        surveys?: boolean;
    };
    sms_subscription_groups?: {
        sms?: boolean;
        sms_transactional?: boolean;
    };
    postal_preference?: boolean;
    telephone_preference?: boolean;
    shipping_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
}
export interface IForceChangePasswordResponse {
    email?: string;
    status?: string;
    error?: string;
}
export interface IRegisteredResponse {
    role?: string;
    chargebee_customer_id?: string;
    expires_in?: number;
    id_token?: string;
    access_token?: string;
    refresh_token?: string;
    app_client_id?: string;
    auth_type?: string;
    shifted_delivery_date?: string;
}
export interface ILogedInResponse {
    role?: string;
    chargebee_customer_id?: string;
    expires_in?: number;
    id_token?: string;
    access_token?: string;
    refresh_token?: string;
    app_client_id?: string;
    auth_type?: string;
}
export interface IVerifyLogedInResponse {
    role?: string;
    chargebee_customer_id?: string;
    app_client_id?: string;
    auth_type?: string;
}
export interface IRefreshResponse {
    role?: string;
    chargebee_customer_id?: string;
    expires_in?: number;
    id_token?: string;
    access_token?: string;
    app_client_id?: string;
    auth_type?: string;
}
export interface IEmailValidationResponse {
    chargebee?: {
        valid?: string;
        description?: string;
    };
    status?: string;
    error?: string;
}
export interface IPublicKeys {
    status?: string;
    chargebee_public_key?: string;
    stripe_public_key?: string;
    chargebee_site?: string;
    error?: string;
}
export interface ISetupIntent {
    id?: number;
    client_secret?: string;
    customer?: string;
    status?: string;
}
export interface IPaymentIntent {
    payment_intent?: {
        id?: number;
        status?: string;
        amount?: number;
        gateway_account_id?: string;
        expires_at?: number;
        payment_method_type?: string;
        created_at?: number;
        modified_at?: number;
        object?: string;
        currency_code?: string;
        gateway?: string;
    };
    status?: string;
    error?: string;
}
export interface ICustomerObject {
    id?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    company?: string;
    allow_direct_debit?: boolean;
    is_location_valid?: boolean;
    created_at?: string;
    created_from_ip?: string;
    taxability?: string;
    entity_code?: string;
    exempt_number?: string;
    resource_version?: number;
    updated_at?: string;
    locale?: string;
    billing_date?: number;
    billing_date_mode?: string;
    billing_day_of_week?: string;
    billing_day_of_week_mode?: string;
    pii_cleared?: string;
    auto_close_invoices?: boolean;
    fraud_flag?: string;
    primary_payment_source_id?: string;
    backup_payment_source_id?: string;
    invoice_notes?: string;
    preferred_currency_code?: string;
    promotional_credits?: number;
    unbilled_charges?: number;
    refundable_credits?: number;
    excess_payments?: number;
    is_einvoice_enabled?: boolean;
    deleted?: boolean;
    registered_for_gst?: boolean;
    consolidated_invoicing?: boolean;
    customer_type?: string;
    client_profile_id?: string;
    billing_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    payment_method?: any;
    relationship?: any;
    cf_additional_email?: string;
    cf_total_orders?: number;
    cf_incomplete_registration?: boolean;
    cf_s2s_consent?: boolean;
    cf_dbp_signup_date?: number;
    cf_dbp_lifetime_sum?: number;
    cf_introductory_discount?: string;
    cf_referral_coupon?: string;
    cf_status?: string;
    multipass_token?: string;
}
export interface ICustomer {
    customer?: ICustomerObject;
}
export interface IPaymentSource {
    id?: string;
    gateway?: string;
    gateway_account_id?: string;
    reference_id?: string;
    card?: {
        funding_type?: string;
        iin?: string;
        last4?: string;
        masked_number?: string;
        object?: string;
        brand?: string;
        expiry_month?: number;
        expiry_year?: number;
    };
    object?: string;
    resource_version?: number;
    updated_at?: number;
    deleted?: boolean;
    customer_id?: string;
    issuing_country?: string;
    status?: string;
    type?: string;
    created_at?: number;
}
export interface IPaymentSourceList {
    list?: Array<IPaymentSource>;
}
export interface ICoupon {
    duration_type?: string;
    item_constraints?: Array<ICouponItemConstraints>;
    name?: string;
    discount_type?: string;
    discount_percentage?: number;
    status?: string;
    object?: string;
    resource_version?: number;
    redemptions?: number;
    invoice_name?: string;
    apply_discount_on?: string;
    apply_on?: string;
    created_at?: number;
    updated_at?: number;
    id?: string;
    discount_amount?: number;
    valid_till?: number;
    currency_code?: string;
    period?: number;
    period_unit?: string;
    max_redemptions?: number;
}
export interface ICouponItemConstraints {
    item_type?: string;
    constraint?: string;
}
export interface IItem {
    id?: string;
    description?: string;
    name?: string;
    status?: string;
    resource_version?: number;
    updated_at?: number;
    item_family_id?: string;
    type?: string;
    is_shippable?: boolean;
    is_giftable?: boolean;
    enabled_for_checkout?: boolean;
    enabled_in_portal?: boolean;
    item_applicability?: string;
    metered?: boolean;
    channel?: string;
    metadata?: any;
    cf_category?: string;
    cf_imageurl?: string;
    object?: string;
}
export interface ISubscriptionItems {
    item_price_id?: string;
    item_type?: string;
    quantity?: number;
    billing_cycles?: number;
    unit_price?: number;
    amount?: number;
    free_quantity?: number;
    object?: string;
    item?: IItem;
}
export interface ISubscriptionObject {
    id?: string;
    billing_period?: number;
    billing_period_unit?: string;
    customer_id?: string;
    status?: string;
    current_term_start?: number;
    current_term_end?: number;
    next_billing_at?: number;
    created_at?: number;
    started_at?: number;
    activated_at?: number;
    updated_at?: number;
    has_scheduled_changes?: boolean;
    channel?: string;
    resource_version?: number;
    deleted?: boolean;
    object?: string;
    currency_code?: string;
    subscription_items?: Array<ISubscriptionItems>;
    shipping_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    due_invoices_count?: number;
    exchange_rate?: number;
    base_currency_code?: string;
    meta_data?: {
        box_id?: string;
    };
    start_date?: number;
    coupon?: ICoupon;
    cf_discount?: string;
    cf_dislikes?: string;
    cf_safe_place?: string;
    cf_delivery_configuration_id?: string;
    cf_recurring_notes?: string;
    cf_w3w?: string;
    cf_type?: string;
}
export interface ISubscription {
    subscription?: ISubscriptionObject;
}
export interface IReferralProgramObject {
    id?: string;
    coupon_id?: string;
    timestamp?: number;
    customer_id?: string;
    friend_id?: string;
    friend_email?: string;
    friend_first_name?: string;
    friend_last_name?: string;
    reward_amount?: number;
    number_of_used_rewards?: string;
}
export interface ICustomerReferralProgramInfo {
    rewards?: Array<IReferralProgramObject>;
}
export interface IPause {
    id?: string;
    pause_date?: number;
    resume_date?: number;
    applied?: number;
    customer_id?: string;
    subscription_id?: string;
}
export interface IPausesResponse {
    pauses?: Array<IPause>;
}
export interface IMarketingPreferences {
    email_subscribe?: string;
    push_subscribe?: string;
    email_subscription_groups?: {
        addons?: boolean;
        general_marketing?: boolean;
        weekly_newsletter?: boolean;
        '3rd_party'?: boolean;
        surveys?: boolean;
    };
    sms_subscription_groups?: {
        sms?: boolean;
        sms_transactional?: boolean;
    };
    postal_preference?: boolean;
    telephone_preference?: boolean;
}
export interface IOrderEstimateResponse {
    original_amount?: number;
    item_level_discount_amount?: number;
    document_level_discount_amount?: number;
    discount_amount?: number;
    final_amount?: number;
    plan?: IOrderEstimateLineItem;
    delivery_fee?: IOrderEstimateLineItem;
    discounts?: Array<{
        object?: string;
        entity_type?: string;
        description?: string;
        amount?: number;
        entity_id?: string;
        discount_percentage?: number;
        discount_type?: string;
    }>;
}
export interface IOrderEstimateLineItem {
    item_price_id?: string;
    entity_type?: string;
    quantity?: number;
    unit_amount?: number;
    original_amount?: number;
    item_level_discount_amount?: number;
    final_amount?: number;
}
export interface IResourceNotFound {
    description?: string;
    status?: string;
    error?: string;
}
export type TRegistrationV1ValidateEmailPostError = '' | 'InvalidEmail';
export type TRegistrationV1StripeSetupIntentPostError = '';
export type TRegistrationV1StripeSetupIntentPutError = '' | 'undefined';
export type TRegistrationV1PaymentIntentPostError =
    | ''
    | 'ChargebeeRequestWithPaymentFailed'
    | 'ChargebeePaymentError'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TRegistrationV1PublicKeysGetError = '';
export type TRegistrationV1RegisterPostError =
    | ''
    | 'InvalidSignUpParams'
    | 'InvalidSignUpParams'
    | 'UserWithThisEmailIsAlreadyRegisteredInChargebee'
    | 'InvalidBillingAddress'
    | 'InvalidShippingAddress'
    | 'CutoffTimePassed'
    | 'InvalidPayment'
    | 'InvalidSetupIntent'
    | 'InvalidPaymentParams'
    | 'SignUpBrokenDependency'
    | 'CognitoSignUpFailed'
    | 'InvalidCognitoToken'
    | 'CognitoLogInFailed'
    | 'CognitoRefreshFailed'
    | 'ChargebeeSignUpFailed'
    | 'CreateChargebeePaymentSourceFailed'
    | 'CreateChargebeeSubscriptionFailed'
    | 'ChargebeeRequestFailedError'
    | 'SignUpFailed';
export type TRegistrationV1SignUpPostError =
    | ''
    | 'InvalidSignUpParams'
    | 'InvalidSignUpParams'
    | 'UserWithThisEmailIsAlreadyRegisteredInChargebee'
    | 'InvalidBillingAddress'
    | 'InvalidShippingAddress'
    | 'CutoffTimePassed'
    | 'SignUpBrokenDependency'
    | 'CognitoSignUpFailed'
    | 'InvalidCognitoToken'
    | 'CognitoLogInFailed'
    | 'CognitoRefreshFailed'
    | 'ChargebeeSignUpFailed'
    | 'CreateChargebeePaymentSourceFailed'
    | 'CreateChargebeeSubscriptionFailed'
    | 'ChargebeeRequestFailedError'
    | 'SignUpFailed';
export type TRegistrationV1LoginPostError =
    | ''
    | 'InvalidLogInParams'
    | 'Unauthorized'
    | 'PasswordChangeRequired'
    | 'CustomerNotAuthorizedWithPassword';
export type TRegistrationV1AuthVerifyPostError = '' | 'Unauthorized' | 'UserNotFound' | 'UserSuspended';
export type TRegistrationV1RefreshPostError = '' | 'InvalidRequestParams' | 'Unauthorized';
export type TRegistrationV1SignOutPostError = '';
export type TRegistrationV1ChangePasswordPostError =
    | ''
    | 'InvalidRequestParams'
    | 'InvalidPasswordException'
    | 'LimitExceededException'
    | 'CognitoException';
export type TRegistrationV1ChangePasswordForcePostError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'ForceChangePasswordConflict'
    | 'TokenDecryptionError'
    | 'ForcePasswordChangeNotRequired'
    | 'ForcePasswordChangeFailed';
export type TRegistrationV1ForgotPasswordPostError =
    | ''
    | 'InvalidRequestParams'
    | 'FPCognitoException'
    | 'CognitoInvalidUsernameException'
    | 'CognitoEmailVerificationException'
    | 'CognitoException'
    | 'ForgotPasswordNotAvailableForSSOUser';
export type TRegistrationV1ForgotPasswordConfirmPostError = '' | 'InvalidRequestParams' | 'CognitoException';
export type TRegistrationV1CustomerGetError =
    | ''
    | 'Unauthorized'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TRegistrationV1CustomerPatchError =
    | ''
    | 'Unauthorized'
    | 'CustomerDataUpdateConflict'
    | 'UpdateEmailError'
    | 'UpdateEmailOperationBlockedForSSOUser'
    | 'UnconfirmedUserCannotChangeEmail'
    | 'InternalUserNotFound'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TRegistrationV1CustomerLatestSubscriptionGetError = '' | 'CustomerDoesNotHaveAnySubscriptions';
export type TRegistrationV1CustomerReferralProgramGetError = '';
export type TRegistrationV1CustomerPausesGetError = '';
export type TRegistrationV1PaymentSourceGetError = '';
export type TRegistrationV1PaymentSourcePostError = '' | 'InvalidParams' | 'InvalidSetupIntent';
export type TRegistrationV1PaymentSourceIdGetError = '' | 'EntityNotFound';
export type TRegistrationV1PaymentSourceIdPatchError = '' | 'EntityNotFound' | 'InvalidSetupIntent';
export type TRegistrationV1PaymentSourceIdDeleteError =
    | ''
    | 'EntityNotFound'
    | 'DeletePaymentSourceConflict'
    | 'PaymentSourceIsInUse';
export type TRegistrationV1CustomerTrackAliasPostError = '' | 'InvalidRequestParams';
export type TRegistrationV1CustomerMarketingPreferencesPatchError = '' | 'InvalidRequestParams' | 'UserNotFound';
export type TRegistrationV1CustomerMarketingPreferencesGetError =
    | ''
    | 'InvalidRequestParams'
    | 'UserNotFound'
    | 'BrazeError';
export type TRegistrationV1OrderEstimatePostError = '' | 'undefined' | 'undefined' | 'undefined';
export type TPartialErrorCodes =
    | TRegistrationV1ValidateEmailPostError
    | TRegistrationV1StripeSetupIntentPostError
    | TRegistrationV1StripeSetupIntentPutError
    | TRegistrationV1PaymentIntentPostError
    | TRegistrationV1PublicKeysGetError
    | TRegistrationV1RegisterPostError
    | TRegistrationV1SignUpPostError
    | TRegistrationV1LoginPostError
    | TRegistrationV1AuthVerifyPostError
    | TRegistrationV1RefreshPostError
    | TRegistrationV1SignOutPostError
    | TRegistrationV1ChangePasswordPostError
    | TRegistrationV1ChangePasswordForcePostError
    | TRegistrationV1ForgotPasswordPostError
    | TRegistrationV1ForgotPasswordConfirmPostError
    | TRegistrationV1CustomerGetError
    | TRegistrationV1CustomerPatchError
    | TRegistrationV1CustomerLatestSubscriptionGetError
    | TRegistrationV1CustomerReferralProgramGetError
    | TRegistrationV1CustomerPausesGetError
    | TRegistrationV1PaymentSourceGetError
    | TRegistrationV1PaymentSourcePostError
    | TRegistrationV1PaymentSourceIdGetError
    | TRegistrationV1PaymentSourceIdPatchError
    | TRegistrationV1PaymentSourceIdDeleteError
    | TRegistrationV1CustomerTrackAliasPostError
    | TRegistrationV1CustomerMarketingPreferencesPatchError
    | TRegistrationV1CustomerMarketingPreferencesGetError
    | TRegistrationV1OrderEstimatePostError
    | '';

export const createApiRequest = (rs: IRequestService) => ({
    // validate customer email
    registrationV1ValidateEmailPost: (
        body: IEmail,
    ): CustomPromise<
        CustomAxiosResponse<IEmailValidationResponse, TRegistrationV1ValidateEmailPostError>,
        IBEError<TRegistrationV1ValidateEmailPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/validate_email`), body),

    // create setup intent with customer in Stripe
    registrationV1StripeSetupIntentPost: (): CustomPromise<
        CustomAxiosResponse<ISetupIntent, TRegistrationV1StripeSetupIntentPostError>,
        IBEError<TRegistrationV1StripeSetupIntentPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/stripe/setup_intent`)),

    // update setup intent with customer in Stripe
    registrationV1StripeSetupIntentPut: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<ISetupIntent, TRegistrationV1StripeSetupIntentPutError>,
        IBEError<TRegistrationV1StripeSetupIntentPutError>
    > => rs.put(formatUrl(API_SERVER_URL + `/registration/api/v1/stripe/setup_intent`), { headers }),

    // creating Payment intent
    registrationV1PaymentIntentPost: (): CustomPromise<
        CustomAxiosResponse<IPaymentIntent, TRegistrationV1PaymentIntentPostError>,
        IBEError<TRegistrationV1PaymentIntentPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_intent`)),

    // receive a Chargebee / Stripe public keys
    registrationV1PublicKeysGet: (): CustomPromise<
        CustomAxiosResponse<IPublicKeys, TRegistrationV1PublicKeysGetError>,
        IBEError<TRegistrationV1PublicKeysGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/public_keys`)),

    // OddBox customer registration
    registrationV1RegisterPost: (
        body: IRegisterRequest,
        headers: { 'App-Client-Id'?: string },
    ): CustomPromise<
        CustomAxiosResponse<IRegisteredResponse, TRegistrationV1RegisterPostError>,
        IBEError<TRegistrationV1RegisterPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/register`), body, { headers }),

    // OddBox customer sign up (without payment details)
    registrationV1SignUpPost: (
        body: ISignUpRequest,
        headers: { 'App-Client-Id'?: string },
    ): CustomPromise<
        CustomAxiosResponse<ILogedInResponse, TRegistrationV1SignUpPostError>,
        IBEError<TRegistrationV1SignUpPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/sign_up`), body, { headers }),

    // OddBox customer log in
    registrationV1LoginPost: (
        body: ICredentials,
        headers: { 'App-Client-Id'?: string },
    ): CustomPromise<
        CustomAxiosResponse<ILogedInResponse, TRegistrationV1LoginPostError>,
        IBEError<TRegistrationV1LoginPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/login`), body, { headers }),

    // Check if the OddBox customer is logged in
    registrationV1AuthVerifyPost: (headers: {
        'App-Client-Id'?: string;
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<IVerifyLogedInResponse, TRegistrationV1AuthVerifyPostError>,
        IBEError<TRegistrationV1AuthVerifyPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/auth_verify`), { headers }),

    // Refresh auth token
    registrationV1RefreshPost: (
        body: IRefresh,
        headers: { 'App-Client-Id'?: string },
    ): CustomPromise<
        CustomAxiosResponse<IRefreshResponse, TRegistrationV1RefreshPostError>,
        IBEError<TRegistrationV1RefreshPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/refresh`), body, { headers }),

    // OddBox customer sign out
    registrationV1SignOutPost: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1SignOutPostError>,
        IBEError<TRegistrationV1SignOutPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/sign_out`), { headers }),

    // Change customer password
    registrationV1ChangePasswordPost: (
        body: IChangePassword,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1ChangePasswordPostError>,
        IBEError<TRegistrationV1ChangePasswordPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/change_password`), body, { headers }),

    // Force change customer password
    registrationV1ChangePasswordForcePost: (
        body: IForceChangePassword,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IForceChangePasswordResponse, TRegistrationV1ChangePasswordForcePostError>,
        IBEError<TRegistrationV1ChangePasswordForcePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/change_password/force`), body, { headers }),

    // Forgot password - send verification code to customer email
    registrationV1ForgotPasswordPost: (
        body: IForgotPassword,
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1ForgotPasswordPostError>,
        IBEError<TRegistrationV1ForgotPasswordPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/forgot_password`), body),

    // Forgot password - confirmation
    registrationV1ForgotPasswordConfirmPost: (
        body: IForgotPasswordConfirm,
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1ForgotPasswordConfirmPostError>,
        IBEError<TRegistrationV1ForgotPasswordConfirmPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/forgot_password/confirm`), body),

    // get customer data
    registrationV1CustomerGet: (
        query: { return_to?: string } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ICustomer, TRegistrationV1CustomerGetError>,
        IBEError<TRegistrationV1CustomerGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/customer`, query), { headers }),

    // update customer data
    registrationV1CustomerPatch: (
        body: ICustomerDataUpdate,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ICustomer, TRegistrationV1CustomerPatchError>,
        IBEError<TRegistrationV1CustomerPatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/registration/api/v1/customer`), body, { headers }),

    // get the latest customer subscription
    registrationV1CustomerLatestSubscriptionGet: (): CustomPromise<
        CustomAxiosResponse<ISubscription, TRegistrationV1CustomerLatestSubscriptionGetError>,
        IBEError<TRegistrationV1CustomerLatestSubscriptionGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/latest_subscription`)),

    // get customer referral program information
    registrationV1CustomerReferralProgramGet: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<ICustomerReferralProgramInfo, TRegistrationV1CustomerReferralProgramGetError>,
        IBEError<TRegistrationV1CustomerReferralProgramGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/referral_program`), { headers }),

    // get all customer pauses
    registrationV1CustomerPausesGet: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<IPausesResponse, TRegistrationV1CustomerPausesGetError>,
        IBEError<TRegistrationV1CustomerPausesGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/pauses`), { headers }),

    // retieve all customer's Payment sources
    registrationV1PaymentSourceGet: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<IPaymentSourceList, TRegistrationV1PaymentSourceGetError>,
        IBEError<TRegistrationV1PaymentSourceGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_source`), { headers }),

    // create new Payment soyrce
    registrationV1PaymentSourcePost: (
        body: IPaymentSourceRequestBody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPaymentSource, TRegistrationV1PaymentSourcePostError>,
        IBEError<TRegistrationV1PaymentSourcePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_source`), body, { headers }),

    // retrieve certain Payment source
    registrationV1PaymentSourceIdGet: (
        payment_source_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPaymentSource, TRegistrationV1PaymentSourceIdGetError>,
        IBEError<TRegistrationV1PaymentSourceIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_source/${payment_source_id}`), { headers }),

    // change Payment source
    registrationV1PaymentSourceIdPatch: (
        payment_source_id: string,
        body: IPaymentSourceRequestBody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPaymentSource, TRegistrationV1PaymentSourceIdPatchError>,
        IBEError<TRegistrationV1PaymentSourceIdPatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_source/${payment_source_id}`), body, { headers }),

    // delete Payment source
    registrationV1PaymentSourceIdDelete: (
        payment_source_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1PaymentSourceIdDeleteError>,
        IBEError<TRegistrationV1PaymentSourceIdDeleteError>
    > => rs.delete(formatUrl(API_SERVER_URL + `/registration/api/v1/payment_source/${payment_source_id}`), { headers }),

    // OddBox tracking customer
    registrationV1CustomerTrackAliasPost: (
        body: ITrackAliasRequestBody,
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1CustomerTrackAliasPostError>,
        IBEError<TRegistrationV1CustomerTrackAliasPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/track-alias`), body),

    // Change customer marketing preferences
    registrationV1CustomerMarketingPreferencesPatch: (
        body: IMarketingPreferences,
    ): CustomPromise<
        CustomAxiosResponse<void, TRegistrationV1CustomerMarketingPreferencesPatchError>,
        IBEError<TRegistrationV1CustomerMarketingPreferencesPatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/marketing-preferences`), body),

    // Get customer marketing preferences
    registrationV1CustomerMarketingPreferencesGet: (): CustomPromise<
        CustomAxiosResponse<IMarketingPreferences, TRegistrationV1CustomerMarketingPreferencesGetError>,
        IBEError<TRegistrationV1CustomerMarketingPreferencesGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/registration/api/v1/customer/marketing-preferences`)),

    // Create estimate for next order
    registrationV1OrderEstimatePost: (
        body: IOrderEstimateRequest,
    ): CustomPromise<
        CustomAxiosResponse<IOrderEstimateResponse, TRegistrationV1OrderEstimatePostError>,
        IBEError<TRegistrationV1OrderEstimatePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/registration/api/v1/order_estimate`), body),
});

const URL = {
    registrationV1ValidateEmailPost: (): string => `/registration/api/v1/validate_email`,
    registrationV1StripeSetupIntentPost: (): string => `/registration/api/v1/stripe/setup_intent`,
    registrationV1StripeSetupIntentPut: (): string => `/registration/api/v1/stripe/setup_intent`,
    registrationV1PaymentIntentPost: (): string => `/registration/api/v1/payment_intent`,
    registrationV1PublicKeysGet: (): string => `/registration/api/v1/public_keys`,
    registrationV1RegisterPost: (): string => `/registration/api/v1/register`,
    registrationV1SignUpPost: (): string => `/registration/api/v1/sign_up`,
    registrationV1LoginPost: (): string => `/registration/api/v1/login`,
    registrationV1AuthVerifyPost: (): string => `/registration/api/v1/auth_verify`,
    registrationV1RefreshPost: (): string => `/registration/api/v1/refresh`,
    registrationV1SignOutPost: (): string => `/registration/api/v1/sign_out`,
    registrationV1ChangePasswordPost: (): string => `/registration/api/v1/change_password`,
    registrationV1ChangePasswordForcePost: (): string => `/registration/api/v1/change_password/force`,
    registrationV1ForgotPasswordPost: (): string => `/registration/api/v1/forgot_password`,
    registrationV1ForgotPasswordConfirmPost: (): string => `/registration/api/v1/forgot_password/confirm`,
    registrationV1CustomerGet: (): string => `/registration/api/v1/customer`,
    registrationV1CustomerPatch: (): string => `/registration/api/v1/customer`,
    registrationV1CustomerLatestSubscriptionGet: (): string => `/registration/api/v1/customer/latest_subscription`,
    registrationV1CustomerReferralProgramGet: (): string => `/registration/api/v1/customer/referral_program`,
    registrationV1CustomerPausesGet: (): string => `/registration/api/v1/customer/pauses`,
    registrationV1PaymentSourceGet: (): string => `/registration/api/v1/payment_source`,
    registrationV1PaymentSourcePost: (): string => `/registration/api/v1/payment_source`,
    registrationV1PaymentSourceIdGet: (payment_source_id: string): string =>
        `/registration/api/v1/payment_source/${payment_source_id}`,
    registrationV1PaymentSourceIdPatch: (payment_source_id: string): string =>
        `/registration/api/v1/payment_source/${payment_source_id}`,
    registrationV1PaymentSourceIdDelete: (payment_source_id: string): string =>
        `/registration/api/v1/payment_source/${payment_source_id}`,
    registrationV1CustomerTrackAliasPost: (): string => `/registration/api/v1/customer/track-alias`,
    registrationV1CustomerMarketingPreferencesPatch: (): string => `/registration/api/v1/customer/marketing-preferences`,
    registrationV1CustomerMarketingPreferencesGet: (): string => `/registration/api/v1/customer/marketing-preferences`,
    registrationV1OrderEstimatePost: (): string => `/registration/api/v1/order_estimate`,
};
// INSERT END
// DON'T REMOVE THIS COMMENTS!!!

export const registrationApiRequest = {
    ...createApiRequest(requestService),
};
export const REGISTRATION_API_URL = URL;
export type IRegistrationApiRequest = Partial<typeof registrationApiRequest>;
